import { __makeTemplateObject } from "tslib";
import * as React from 'react';
import styled from 'styled-components';
import { Close } from '@kvika/icons';
import Button, { ButtonBackgroundType } from '@kvika/button';
import { StyledModalHeader, StyledHeaderTitle } from './styles/ModalStyles';
import ModalContext from './ModalContext';
var StyledCloseButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-left: 16px;\n  height: 24px;\n"], ["\n  margin-left: 16px;\n  height: 24px;\n"])));
var ModalHeader = function (_a) {
    var children = _a.children, _b = _a.showCloseButton, showCloseButton = _b === void 0 ? true : _b, className = _a.className;
    var _c = React.useContext(ModalContext), onClose = _c.onClose, testId = _c.testId;
    return (React.createElement(StyledModalHeader, { className: className },
        React.createElement(StyledHeaderTitle, null, children),
        showCloseButton && (React.createElement(StyledCloseButton, { backgroundType: ButtonBackgroundType.Text, testId: "".concat(testId, "-close-button"), onClick: function () {
                if (typeof onClose === 'function') {
                    onClose();
                }
            } },
            React.createElement(Close, null)))));
};
export default ModalHeader;
var templateObject_1;
//# sourceMappingURL=ModalHeader.js.map